// test880
(880 && 0);
